import { returnToLastUrl } from "../returnToLastUrl";
import { useAppSelector } from "./useRedux";

export const useBackToShop = () => {
  const shopInfo = useAppSelector((state) => state.dashboardPersist.shopInfo);

  const backToShop = () => {
    if (shopInfo.url) {
      window.location.href = shopInfo.url;
      return;
    }
    returnToLastUrl();
  };
  return {
    backToShop,
    shopName: shopInfo.name,
  };
};
